import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { useAtlasV2MetricByWeekId } from 'src/serverProxy/useAtlasV2MetricByWeekId';
import DonutChartLoading from 'src/components/Charts/Donut/DonutChartLoading';
import CircularProgressPercentage from 'src/components/common/UploadAnimation/CircularProgressPercentage';
import BeaconChartWithLegend from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconChartWithLegend';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { formatMetric } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import { Grid } from '@mui/material';

/**
 * Shows donut chart and spline charts for the top section Ratings
 */
export const AtlasV2RatingsTopSection = () => {
  const { lastPrimaryValue, isLoading } = useAtlasV2MetricByWeekId({
    indexName: 'sales',
    fieldName: 'reviewsRating',
    requestBuilder: (rb) => {
      return rb.addConditionRangeFilter('reviewsRating', 0.01, 5);
    }
  });

  return (
    <BeaconChartWithLegend title="Rating" showExportMenu={false}>
      <Grid display="grid" alignItems="center" justifyContent="space-between" gridTemplateColumns="308px 655px">
        <div style={{ width: '308px', height: '308px' }}>
          {isLoading ? (
            <DonutChartLoading />
          ) : (
            <CircularProgressPercentage
              percentage={lastPrimaryValue / 5}
              customLabel={
                <Flex gap="sm" alignItems="center" flexDirection="column">
                  <Text
                    sx={{
                      fontSize: '48px',
                      fontWeight: 'bold'
                    }}
                  >
                    {`${formatMetric(lastPrimaryValue, METRICTYPE.DECIMAL, {
                      showFullValue: false,
                      decimalPlaces: 1
                    })}`}
                  </Text>
                  <Text
                    sx={{
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                  >
                    Avg. Star Rating
                  </Text>
                </Flex>
              }
            />
          )}
        </div>
        <div style={{ flex: 1 }}>
          <AtlasV2ComparableSplineChart
            indexName="sales"
            fieldName="reviewsRating"
            showTitleSummary={false}
            splineChartLoadingProps={{
              width: 664
            }}
            chartOptionsOverride={{
              chart: {
                height: 280,
                width: 664
              }
            }}
            requestBuilder={(builder) => builder.addConditionRangeFilter('reviewsRating', 0.1, 5)}
          />
        </div>
      </Grid>
    </BeaconChartWithLegend>
  );
};
